export default "__VITE_ASSET__CVWJ1C8N__"